<div class="day" fxFlex [ngClass]="{ today: isToday$ | async }">
  <div *ngFor="let hour of hours; trackBy: trackByHour" class="hour"></div>

  <ng-container *ngIf="groupedEvents$ | async as groupedEvents">
    <div fxLayout="column">
      <ng-container *ngFor="let group of groupedEvents; trackBy: trackByIndex">
        <pr-calendar-event-time
          *ngFor="let event of group; let i = index; trackBy: trackByEvent"
          [event]="event"
          [day]="day$ | async"
          [index]="i"
        />
      </ng-container>
    </div>
  </ng-container>
</div>
